export type Shortcut = {
    name: string;
    command: string | string[];
    separator?: string;
};

export type ShortcutList = {
    name: string;
    shortcuts: Shortcut[];
};

export const shortcuts: ShortcutList[] = [
    {
        name: 'whiteboard:helpDialog.view',
        shortcuts: [
            {
                name: 'whiteboard:buttons.zoomIn',
                command: 'Cmd++'
            },
            {
                name: 'whiteboard:buttons.zoomOut',
                command: 'Cmd+-'
            },
            {
                name: 'whiteboard:buttons.resetZoom',
                command: 'Cmd+0'
            },
            {
                name: 'whiteboard:helpDialog.zoomToFit',
                command: 'Shift+1'
            },
            {
                name: 'whiteboard:helpDialog.zoomToSelection',
                command: 'Shift+2'
            },
            {
                name: 'whiteboard:labels.showGrid',
                command: "Cmd+'"
            },
            {
                name: 'whiteboard:stats.title',
                command: 'Option+/'
            }
        ]
    },
    {
        name: 'whiteboard:helpDialog.editor',
        shortcuts: [
            {
                name: 'whiteboard:labels.selectAll',
                command: 'Cmd+A'
            },
            {
                name: 'whiteboard:labels.multiSelect',
                command: 'Shift+Click'
            },
            {
                name: 'whiteboard:labels.moveCanvas',
                command: ['Space+Drag', 'Wheel+Drag']
            },
            {
                name: 'whiteboard:labels.cut',
                command: 'Cmd+X'
            },
            {
                name: 'whiteboard:labels.copy',
                command: 'Cmd+C'
            },
            {
                name: 'whiteboard:labels.paste',
                command: 'Cmd+V'
            },
            {
                name: 'whiteboard:labels.copyAsPng',
                command: 'Shift+Option+C'
            },
            {
                name: 'whiteboard:labels.copyStyles',
                command: 'Cmd+Option+C'
            },
            {
                name: 'whiteboard:labels.pasteStyles',
                command: 'Cmd+Option+V'
            },
            {
                name: 'common:delete',
                command: 'Delete'
            },
            {
                name: 'whiteboard:labels.sendToBack',
                command: 'Cmd+Option+['
            },
            {
                name: 'whiteboard:labels.bringToFront',
                command: 'Cmd+Option+]'
            },
            {
                name: 'whiteboard:labels.sendBackward',
                command: 'Cmd+['
            },
            {
                name: 'whiteboard:labels.bringForward',
                command: 'Cmd+]'
            },
            {
                name: 'whiteboard:labels.alignTop',
                command: 'Cmd+Shift+Up'
            },
            {
                name: 'whiteboard:labels.alignBottom',
                command: 'Cmd+Shift+Down'
            },
            {
                name: 'whiteboard:labels.alignLeft',
                command: 'Cmd+Shift+Left'
            },
            {
                name: 'whiteboard:labels.alignRight',
                command: 'Cmd+Shift+Right'
            },
            {
                name: 'whiteboard:labels.duplicateSelection',
                command: ['Cmd+D', 'Option+Drag']
            },
            {
                name: 'whiteboard:buttons.undo',
                command: 'Cmd+Z'
            },
            {
                name: 'whiteboard:buttons.redo',
                command: 'Cmd+Shift+Z'
            },
            {
                name: 'whiteboard:labels.group',
                command: 'Cmd+G'
            },
            {
                name: 'whiteboard:labels.ungroup',
                command: 'Cmd+Shift+G'
            },
            {
                name: 'whiteboard:labels.flipHorizontal',
                command: 'Shift+H'
            },
            {
                name: 'whiteboard:labels.flipVertical',
                command: 'Shift+V'
            },
            {
                name: 'whiteboard:labels.showStroke',
                command: 'S'
            },
            {
                name: 'whiteboard:labels.showBackground',
                command: 'G'
            }
        ]
    },
    {
        name: 'whiteboard:helpDialog.shapes',
        shortcuts: [
            {
                name: 'whiteboard:toolBar.selection',
                command: ['V', '1']
            },
            {
                name: 'whiteboard:toolBar.rectangle',
                command: ['R', '2']
            },
            {
                name: 'whiteboard:toolBar.diamond',
                command: ['D', '3']
            },
            {
                name: 'whiteboard:toolBar.ellipse',
                command: ['E', '4']
            },
            {
                name: 'whiteboard:toolBar.arrow',
                command: ['A', '5']
            },
            {
                name: 'whiteboard:toolBar.line',
                command: ['P', '6']
            },
            {
                name: 'whiteboard:toolBar.freedraw',
                command: ['Shift+P', '7']
            },
            {
                name: 'whiteboard:toolBar.text',
                command: ['T', '8']
            },
            {
                name: 'whiteboard:helpDialog.editSelectedShape',
                command: ['Enter', 'Double-click']
            },
            {
                name: 'whiteboard:helpDialog.textNewLine',
                command: ['Enter', 'Shift+Enter']
            },
            {
                name: 'whiteboard:helpDialog.textFinish',
                command: ['Esc', 'Cmd+Enter']
            },
            {
                name: 'whiteboard:helpDialog.curvedArrow',
                command: ['A', 'Click', 'Click', '...'],
                separator: ''
            },
            {
                name: 'whiteboard:helpDialog.curvedLine',
                command: ['L', 'Click', 'Click', '...'],
                separator: ''
            },
            {
                name: 'whiteboard:toolBar.lock',
                command: 'Q'
            },
            {
                name: 'whiteboard:helpDialog.preventBinding',
                command: 'Cmd'
            }
        ]
    }
];
